import React, {useCallback, useState} from 'react'
import {useHistory} from 'react-router'

import {useActionApi} from 'hooks'
import Api from 'api'

import {HygienistBackendJob} from 'components/EditJob'
import {HygienistJobDetails} from 'components/HygienistJobDetails'
import {NoResumeActions} from 'components/HygienistJobDetails/NoResumeActions'
import {WithdrawActions} from 'components/HygienistJobDetails/WithdrawActions'
import {SuccessAction} from 'components/HygienistJobDetails/SuccessAction'
import FixedLoader from 'components/FixedLoader'
import FixedError from 'components/FixedError'
import {TopBarRedesigned} from "components/TopBarRedesigned";
import Popup from "components/Popup";

export default function JobPostDetailsPage() {
  const history = useHistory()

  const {job}: { job: HygienistBackendJob } = history.location.state as any
  const {hygienistUser}: { hygienistUser: any } = history.location.state as any
  const hireResumeUrl = hygienistUser?.hygienist?.hireResumeUrl

  const [applyingLoading, applyingError, applyForJob] = useActionApi({
    apiMethod: Api.applyForHireJob,
    onSuccess: useCallback(() => {
      setApplicationSuccessfulPopupOpened(true);
    }, [history])
  })
  const [withdrawingLoading, withdrawingError, withdrawJob] = useActionApi({
    apiMethod: Api.withDrawForHireJob,
    onSuccess: useCallback(() => {
      setApplicationWithdrawnPopupOpened(true)
    }, [history])
  })

  const [noResumePopupOpened, setNoResumePopupOpened] = useState(false)
  const [withdrawPopupOpened, setWithdrawPopupOpened] = useState(false)
  const [applicationSuccessfulPopupOpened, setApplicationSuccessfulPopupOpened] = useState(false)
  const [applicationWithdrawnPopupOpened, setApplicationWithdrawnPopupOpened] = useState(false)

  const onApplyButtonClick = async () => {
    if (hireResumeUrl) {
      await applyForJob(job.id);
    } else {
      setNoResumePopupOpened(true);
    }
  }

  const onWithdrawButtonClick = () => {
    setWithdrawPopupOpened(true);
  }

  const onNoResumePopupClose = () => {
    setNoResumePopupOpened(false);
  }
  const onWithdrawPopupClose = () => {
    setWithdrawPopupOpened(false);
  }
  const onApplicationSuccessfulPopupClose = () => {
    setApplicationSuccessfulPopupOpened(false);
  }
  const onApplicationWithdrawnPopupClose = () => {
    setApplicationWithdrawnPopupOpened(false);
  }

  const onResumeUploaded = async () => {
    onNoResumePopupClose();
    await applyForJob(job.id);
  }

  const onApplicationWithdraw = async () => {
    onWithdrawPopupClose();
    await withdrawJob({
      applicationId: job.applicationId as number
    });
  }

  const onApplicationAppliedConfirm = () => {
    onApplicationSuccessfulPopupClose();
    history.replace('jobPostsList');
  }
  const onApplicationWithdrawnConfirm = () => {
    onApplicationWithdrawnPopupClose();
    history.replace('jobPostsList');
  }

  return (
    <>
      <TopBarRedesigned
        title='Job Details'
        onBack={() => {
          history.goBack()
        }}
      />
      <HygienistJobDetails
        job={job}
        onApply={onApplyButtonClick}
        onWithdraw={onWithdrawButtonClick}
      />
      <Popup
        opened={noResumePopupOpened}
        onClose={onNoResumePopupClose}
      >
        <NoResumeActions onCancel={onNoResumePopupClose} onResumeUploaded={onResumeUploaded}/>
      </Popup>
      <Popup
        opened={withdrawPopupOpened}
        onClose={onWithdrawPopupClose}
      >
        <WithdrawActions onCancel={onWithdrawPopupClose} onApplicationWithdraw={onApplicationWithdraw}/>
      </Popup>
      <Popup
        opened={applicationSuccessfulPopupOpened}
        onClose={onApplicationSuccessfulPopupClose}
      >
        <SuccessAction
          title="Application Sent"
          description="The Dental Office will be in touch with you if your application is successful. Good luck!"
          onConfirm={onApplicationAppliedConfirm}
        />
      </Popup>
      <Popup
        opened={applicationWithdrawnPopupOpened}
        onClose={onApplicationWithdrawnPopupClose}
      >
        <SuccessAction
          title="Application Withdrawn"
          description="Your application has been successfully withdrawn."
          onConfirm={onApplicationWithdrawnConfirm}
        />
      </Popup>
      <FixedLoader loading={applyingLoading || withdrawingLoading}/>
      <FixedError error={applyingError || withdrawingError}/>
    </>
  )
}
